import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-84" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.58,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-85" data-mp="23x4lypi7100n">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-teal sm:text-xs" data-id="element-86" data-mp="30k984mvrs3n6">
          THE COMPLETE SPANISH CURRICULUM
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-blue sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-87" data-mp="2rt0jw53fi52f">
          Teach a Full Year of{' '}
          <span className="italic text-brand-purple" data-id="element-88" data-mp="3fgi6znbr0ez2">Spanish</span> in Just 5
          Minutes of Prep
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-89" data-mp="2fficpvth3br3">
          Ready-to-teach lessons, hands-on activities and built-in assessments —
          from Grade K to Year 12. No Spanish fluency required.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/mvemn64HHGRXehfMwXbfDz/ChatGPT_Image_13_ago_2026,_15_30_11-Photoroom.png" alt="Spanish Ready curriculum bundle with ten volumes, digital teaching materials, and five bonuses" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-90" data-mp="2p6mpcovoekir" />
        <div className="flex w-full flex-col items-center" data-id="element-91" data-mp="3834qfwwezwro">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-92" data-mp="3353515binld1">
            GET THE SPANISH READY PACK
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-93" data-mp="18r3bhtyncvww">
            ✓ Instant digital download{' '}
            <span className="px-1 text-brand-orange" data-id="element-94" data-mp="38v5uv4nkxwrj">·</span> ✓ Print &amp;
            digital ready <span className="px-1 text-brand-orange" data-id="element-95" data-mp="3dsxy2utod5b1">·</span> ✓
            30-day guarantee
          </p>
        </div>
      </motion.div>
    </section>;
}